import { useCallback, useRef } from "react";

/** Long-press detector — fires `onLongPress` after `delay` ms unless the press
 * is cancelled. Returns `{onPressStart, onPressEnd, didFire}` plus a click
 * handler that swallows the synthetic click when a long-press fired. */
export default function useLongPress({ onLongPress, delay = 380, enabled = true }) {
  const timer = useRef(null);
  const fired = useRef(false);

  const onPressStart = useCallback(() => {
    if (!enabled) return;
    fired.current = false;
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      fired.current = true;
      onLongPress?.();
    }, delay);
  }, [enabled, delay, onLongPress]);

  const onPressEnd = useCallback(() => {
    clearTimeout(timer.current);
  }, []);

  const guardClick = useCallback((e) => {
    if (fired.current) {
      e.preventDefault();
      fired.current = false;
      return true;
    }
    return false;
  }, []);

  return { onPressStart, onPressEnd, guardClick };
}
